import { formatDate, formatDateTime } from "../utils/SaitUtils";

/*
	Obbligatori:
		headerName
		field
	Facoltativi:
		width
*/

export default function SaitDateColumn(props) {
	return {
		valueFormatter: (value, row, column, apiRef) => (props.time ? formatDateTime(value) : formatDate(value)),
		headerName: props.headerName,
		width: props.width || (props.time ? 120 : 90),
		field: props.field,
		hidden: props.hidden || false,
		sortable: props.sortable !== null && props.sortable !== undefined ? props.sortable : true,
		type: props.type || (props.time ? "dateTime" : "date"),
		flex: props.flex,
		objmod: props.objmod,
		renderCell: props.renderCell,
		startPinned: props.startPinned,
		endPinned: props.endPinned,
	};
}
